import type { AxiosInstance } from 'axios';
import type { TokenizeRequest, TokenizeResponse } from '@/types';

export const countTokens = async (
  api: AxiosInstance,
  inputs: TokenizeRequest['inputs'],
): Promise<number> => {
  const resp = await api.post<TokenizeResponse>('/text/tokenize', {
    inputs,
  });
  return resp?.data?.tokens ?? 0;
};

